import { render, staticRenderFns } from "./button-gray-outline.vue?vue&type=template&id=338a1d11"
import script from "./button-gray-outline.vue?vue&type=script&lang=js"
export * from "./button-gray-outline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports